import { Component, Input, AfterViewInit } from '@angular/core';
import { ToastConfig } from 'src/shared/services/toast.service';
import { v4 as uuid } from 'uuid';
import { Toast } from 'bootstrap';

@Component({
  selector: 'cert-toast',
  templateUrl: './toast.component.html',
  styles: ``,
  standalone: false,
})
export class ToastComponent implements AfterViewInit {
  @Input() public toastConfig!: ToastConfig;
  public toastId: string;

  constructor() {
    this.toastId = uuid();
  }

  ngAfterViewInit() {
    const toastEl = document.getElementById(this.toastId) as Element;
    const autohide =
      this.toastConfig.durationSeconds != null
        ? true
        : this.toastConfig.type === 'success' || this.toastConfig.type === 'info';
    const delay = this.toastConfig.durationSeconds != null ? this.toastConfig.durationSeconds * 1000 : 2500;
    const toast = new Toast(toastEl, { autohide, delay });

    toast.show();
  }
}
